/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import employerStatisticsMetricsType from "./types/employerStatisticsMetricsType";
import {
  Wrapper,
  Header,
  Body,
  Row,
  Column,
  Number,
  Description,
} from "./styles/employer-statistics-metrics-styles";

export const EmployerStatisticsMetrics = ({ loading, employerMetrics }) => (
  <Wrapper data-test-id="employer-statistics-metrics">
    {loading && <WidgetLoading />}
    <Header className="panel-heading">
      <div className="panel-title">Statistics</div>
    </Header>
    <Body>
      <Row>
        <Column flex={1} data-test-id="live-jobs">
          <Number fontSize="large">
            {employerMetrics && employerMetrics.statistics.liveJobs}
          </Number>
          <Description>Live Jobs</Description>
        </Column>
        <Column flex={1} data-test-id="placements">
          <Number fontSize="large">
            {employerMetrics && employerMetrics.statistics.placements}
          </Number>
          <Description>Placements</Description>
        </Column>
      </Row>
    </Body>
  </Wrapper>
);

EmployerStatisticsMetrics.propTypes = {
  loading: PropTypes.bool.isRequired,
  employerMetrics: employerStatisticsMetricsType,
};

EmployerStatisticsMetrics.defaultProps = {
  employerMetrics: PropTypes.shape({
    statistics: PropTypes.shape({
      liveJobs: PropTypes.isNull,
      placements: PropTypes.isNull,
    }),
  }),
};

const mapStateToProps = (state) => ({
  loading: state.dashboard.loading,
  employerMetrics: state.dashboard.employerMetrics,
});

export default connect(mapStateToProps, {})(EmployerStatisticsMetrics);
